import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { ReactNode } from 'react';
import { createIDBPersister } from '../persister/createPersister';

const PERSIST_MAX_AGE = 1000 * 60 * 60 * 24;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: PERSIST_MAX_AGE,
    },
  },
});

const ProviderPersistQueryClient = ({ children }: { children: ReactNode }) => {
  const { user, getSession } = useUser();
  const session = getSession();
  const persister = createIDBPersister(`v1_${session?.fleet.id}_${user?.id}`);
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister, maxAge: PERSIST_MAX_AGE }}>
      {children}
    </PersistQueryClientProvider>
  );
};

export { ProviderPersistQueryClient, queryClient };
